import { useField } from "formik";
import React, { ReactNode } from "react";
import InputCheckbox from "../Checkbox";
import { FormFieldProps } from "../interfaces";

interface Props extends FormFieldProps {
  label: ReactNode;
}

const CheckboxField: React.FC<Props> = (props) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });

  return (
    <InputCheckbox
      {...field}
      {...props}
      hasError={!!(meta.error && meta.touched)}
      errorMessage={meta.error}
    />
  );
};

export default CheckboxField;
